// extracted by mini-css-extract-plugin
export default {"row":"createCompetition_row__0kmUM","col":"createCompetition_col__oh39+","card":"createCompetition_card__7wNJR"};